import { EntityTemplateField, isContractStandardField } from "../../entityTemplates/EntityTemplate.types";
import { ContractExtractionResponse, FieldCitation } from "../addContractButton/createContractPane/CreateContractPane.types";

/** Citations keyed the way a template field identifies itself, so a row can find its own. */
export function buildCitationLookup(extraction: ContractExtractionResponse | undefined): (field: EntityTemplateField) => FieldCitation | undefined {
    const byStandardField = new Map(extraction?.standardFields.filter((field) => field.citation).map((field) => [field.fieldIdentifier, field.citation!]));
    const byCustomField = new Map(extraction?.customFields.filter((field) => field.citation).map((field) => [field.customInputFieldId, field.citation!]));

    return (field: EntityTemplateField) => {
        if (field.standardFieldIdentifier) {
            return isContractStandardField(field.standardFieldIdentifier) ? byStandardField.get(field.standardFieldIdentifier) : undefined;
        }

        return field.customInputFieldId ? byCustomField.get(field.customInputFieldId) : undefined;
    };
}
